import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface FilterStoreProps {
  sideMenuOpen: boolean;
  timezoneDisplay: 'utc' | 'cet';
}

interface FilterStoreActions {
  setSideMenuOpen: (newStatus: boolean) => void;
  setTimezoneDisplay: (newTimezone: 'utc' | 'cet') => void;
}

const useSettingsStore = create(
  persist<FilterStoreProps & FilterStoreActions>(
    (set) => ({
      sideMenuOpen: true,
      timezoneDisplay: 'cet',
      setSideMenuOpen: (newStatus: boolean) => {
        set({ sideMenuOpen: newStatus });
      },
      setTimezoneDisplay: (newTimezone: 'utc' | 'cet') => {
        set({ timezoneDisplay: newTimezone });
      },
    }),
    {
      name: 'settingsStorage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useSettingsStore;
